<template>
    <v-container class="app-background-color" fill-height fluid pa-0 style="overflow: hidden;">
        <system-header :title="title" app></system-header>
        <v-container fluid pa-0 style="height: calc(100vh - 180px); overflow-y: auto; overflow-x:hidden; min-width: 800px;">
            <slot></slot>
        </v-container>
        <transition name="fade">
            <system-footer v-if="shouldShowBottomBar"></system-footer>
        </transition>
        <AudioTranscriptSideDrawer v-if="!frameworkLoading"></AudioTranscriptSideDrawer>
        <transition name="fade-transition">
            <journey-paused-overlay v-if="$store.state.journey.paused" :time="2"></journey-paused-overlay>
        </transition>
        <system-error-overlay></system-error-overlay>
        <app-settings-drawer v-if="!frameworkLoading"></app-settings-drawer>
        <FrameworkSoundPlayer></FrameworkSoundPlayer>
    </v-container>
</template>

<script>
    import SystemFooter from "./SystemFooter";
    import SystemHeader from "./SystemHeader";
    import AudioTranscriptSideDrawer from "./general/AudioTranscriptSideDrawer";
    import JourneyPausedOverlay from "./general/JourneyPausedOverlay";
    import SystemErrorOverlay from "./general/SystemErrorOverlay";
    import AppSettingsDrawer from "./general/AppSettingsDrawer";
    import FrameworkSoundPlayer from "./sounds/FrameworkSoundPlayer";

    export default {
        components: {
            SystemFooter,
            SystemHeader,
            AudioTranscriptSideDrawer,
            JourneyPausedOverlay,
            SystemErrorOverlay,
            AppSettingsDrawer,
            FrameworkSoundPlayer
        },
        name: "main-layout",
        computed:
            {
                frameworkLoading(){
                  return this.$store.state.globalLoading;
                },
                maxHeight() {
                    return window.innerHeight - 180;
                }
                ,
                title() {
                    if (!this.$store.state.journey.journey) {
                        return this.$t('general.welcome');
                    }
                    const id = this.$store.state.journey.journey.title_textassetid;
                    const ta = this.$ta(id);
                    if (id !== ta) {
                        return ta;
                    }
                    return this.$t('general.welcome');
                }
                ,
                assessment() {
                    return this.$store.state.assessment.assessment;
                }
                ,
                shouldShowBottomBar() {
                    return this.assessment && this.$store.state.auth.authToken && !this.$store.state.auth.onBreak;
                }
            }
    }
</script>

<style>

</style>
